function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
}

function parseNumberWithDecimals(numberString) {
    const number = parseFloat(
        numberString
            .replace(/\s/g, "")
            .replace(",", ".")
            .replace(/[^0-9.]/g, "")
    );
    return isNaN(number) ? 0 : number;
}

function formatNumberWithCommas(number) {
    return number
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        .replace(".", ",");
}

function animateNumber(element, finalNumber, duration, delay) {
    const startNumber = 0;
    const isDecimal = finalNumber % 1 !== 0;

    function updateNumber(startTime) {
        return function (currentTime) {
            const elapsedTime = currentTime - startTime;
            if (elapsedTime >= duration) {
                element.textContent = formatNumberWithCommas(finalNumber);
            } else {
                const progress = elapsedTime / duration;
                const increment = (finalNumber - startNumber) * progress;
                const currentNumber = Math.abs(startNumber + increment);

                const roundedNumber = isDecimal
                    ? parseFloat(currentNumber.toFixed(1))
                    : Math.round(currentNumber);

                element.textContent = formatNumberWithCommas(roundedNumber);

                // Schedule the next animation frame
                scheduleAnimationFrame(startTime);
            }
        };
    }

    function scheduleAnimationFrame(startTime) {
        setTimeout(function () {
            requestAnimationFrame(updateNumber(startTime));
        }, 50);
    }

    setTimeout(function () {
        const startTime = performance.now();
        element.style.visibility = "visible";
        requestAnimationFrame(updateNumber(startTime));
    }, delay);
}

function handleScroll() {
    if (document.querySelector('.number-ride')) {
        const numberElements = document.querySelectorAll(".number-ride");
        numberElements.forEach((element) => {
            if (
                isElementInViewport(element) &&
                element.style.visibility !== "visible"
            ) {
                const originalNumber = parseNumberWithDecimals(element.textContent);
                animateNumber(element, originalNumber, 1500, 300);
            }
        });
    }
}

function handleLoad() {
    if (document.querySelector('.number-ride')) {
        const numberElements = document.querySelectorAll(".number-ride");
        numberElements.forEach((element) => {
            if (isElementInViewport(element)) {
                const originalNumber = parseNumberWithDecimals(element.textContent);
                animateNumber(element, originalNumber, 1000, 100);
            }
        });
    }
}

window.addEventListener("scroll", handleScroll);
window.addEventListener("load", handleLoad);
